import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { onAuthLost } from './api';
import { queryClient } from './lib/queryClient';
import { toast } from './lib/toast';
import { router } from './router';
import { s } from './strings';
import './index.css';

// When a refresh fails the API client drops the session; send the user to sign in.
onAuthLost(() => {
  queryClient.clear();
  toast.info(s.errors.sessionExpired);
  const here = router.state.location;
  if (!here.pathname.startsWith('/login')) {
    void router.navigate({ to: '/login', search: { redirect: here.href } });
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
